export default "__VITE_ASSET__b79d7f32__"